import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_ID;

let loaded = false;
function loadGtag() {
  if (loaded || !GA_ID || typeof window === "undefined") return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
}

/**
 * Mount once in App. Loads GA4 (if REACT_APP_GA4_ID is set) and sends a
 * page_view on every route change. Public-facing pages only — we skip
 * app routes to reduce noise and avoid tracking authenticated activity.
 */
const PUBLIC_ROUTES = new Set(["/", "/pricing", "/login", "/signup", "/forgot-password", "/reset-password", "/accept-invite"]);

export default function Analytics() {
  const location = useLocation();
  useEffect(() => {
    if (!GA_ID) return;
    loadGtag();
    if (typeof window === "undefined" || !window.gtag) return;
    if (!PUBLIC_ROUTES.has(location.pathname)) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
  return null;
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}
